import { ErrorState } from "$components/error-state";
import React, { type ComponentType, lazy } from "react";

type ModuleWithDefault = { default: ComponentType<any> };

export function lazyLoad(
  importStatement: () => Promise<ModuleWithDefault>,
): React.LazyExoticComponent<React.ComponentType<any>> {
  return lazy(() =>
    importStatement().catch((error) => {
      console.error(error);
      return {
        default: () => (
          <ErrorState
            variant="boundary"
            details={{
              name: error?.name,
              message: error?.message,
              stack: error?.stack,
            }}
          />
        ),
      };
    }),
  );
}
